import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import axios from "axios";
import { Icon } from "./Icon";

const TimezoneSetup: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [setting, setSetting] = useState(false);
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      navigate("/login");
      return;
    }

    // Store the token
    localStorage.setItem("access_token", token);

    // Auto-detect and set timezone
    detectAndSetTimezone();
  }, [token, navigate]);

  const detectAndSetTimezone = async () => {
    setSetting(true);

    try {
      // Get the user's timezone
      const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

      // Send timezone to backend
      await axios.put(
        "/api/user/timezone",
        { timezone },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );

      // Redirect to dashboard
      navigate("/dashboard");
    } catch (error) {
      console.error("Error setting timezone:", error);
      // Even if timezone setting fails, still redirect to dashboard
      navigate("/dashboard");
    } finally {
      setSetting(false);
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: "#0f1419",
      }}
    >
      <div
        style={{
          backgroundColor: "#2d3748",
          padding: "40px",
          borderRadius: "12px",
          textAlign: "center",
          maxWidth: "400px",
          width: "90%",
        }}
      >
        <div style={{ marginBottom: "20px" }}>
          <Icon name="globe" size={48} color="#9146FF" />
        </div>
        <h2 style={{ color: "#e2e8f0", marginBottom: "16px" }}>
          Setting up your account...
        </h2>
        <p style={{ color: "#cbd5e0", marginBottom: "20px" }}>
          {setting
            ? "Detecting your timezone and configuring your preferences..."
            : "Please wait while we set up your account."}
        </p>

        <div
          style={{
            width: "100%",
            height: "4px",
            backgroundColor: "#4a5568",
            borderRadius: "2px",
            overflow: "hidden",
          }}
        >
          <div
            style={{
              width: setting ? "100%" : "50%",
              height: "100%",
              backgroundColor: "#9146FF",
              borderRadius: "2px",
              transition: "width 0.3s ease",
            }}
          />
        </div>

        <p style={{ color: "#a0aec0", fontSize: "12px", marginTop: "16px" }}>
          You&apos;ll be redirected to your dashboard shortly.
        </p>
      </div>
    </div>
  );
};

export default TimezoneSetup;
